import DecorativeSection from '../components/DecorativeSection';
import Container from '../components/Container';
import Section from '../components/Section';
import Button from '../components/Button';
import BrandLogos from '../components/BrandLogos';
import InsuranceLogos from '../components/InsuranceLogos';
import HeroSection from '../components/HeroSection';
import ServiceCard from '../components/ServiceCard';
import DiamondDivider from '../components/DiamondDivider';
import SEO from '../components/SEO';
import { getAllPosts, formatDate } from '../lib/blog';
import { getCatalogImages, getBrandBySlug, getProductDisplayName } from '../lib/catalogData';
import { useState, useEffect } from 'react';

// Ricava un nome leggibile dalla chiave prodotto del manifest catalogo
function formatProductName(key) {
  return key
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

// Brand dei nuovi arrivi in vetrina in home
const NEW_ARRIVALS_BRAND = 'dsquared';

const interiorImages = [
  '/interno negozio/interno-negozio-ottica-bellodi-torino-1.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-2.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-3.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-4.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-5.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-6.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-7.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-8.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-9.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-10.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-11.webp',
  '/interno negozio/interno-negozio-ottica-bellodi-torino-12.webp'
];

const testimonials = [
  {
    name: 'Giorgio Benacchio',
    text: 'Grande competenza e precisione tecnica, estrema gentilezza e prezzi buoni sia per occhiali da vista e sole che per lenti a contatto. Molto validi anche per riparazioni, danno sempre il consiglio giusto. Offrono anche il caffè ^_^ Si consiglia caldamente; mi servo da loro da quasi vent\'anni e sono sempre contento. Purtroppo professionisti così sono sempre più rari.'
  },
  {
    name: 'Silvia N.',
    text: 'Ottica Bellodi professionalità, disponibilità e simpatia sono il fiore all\'occhiello di questo storico e nel contempo moderno negozio. Puntualità, precisione ed attenzione verso il Cliente!'
  },
  {
    name: 'Manuela P.',
    text: 'Ho avuto un\'esperienza fantastica presso il negozio di ottica! Il personale è stato estremamente professionale e disponibile, guidandomi nella scelta degli occhiali perfetti per mi figlio. La varietà di montature è ottima e i prezzi sono competitivi. Inoltre, ho apprezzato molto la qualità delle lenti e il servizio post-vendita (mio figlio ha rotto gli occhiali dopo poco e sono riusciti prontamente a riaggiustarli). Consiglio!'
  },
  {
    name: 'Michela G.',
    text: 'Sono cliente fin da quand\'ero bambina dell\'Ottica Bellodi, presso la quale ho sempre acquistato i miei occhiali da vista. Personale competente, gentile e professionale, capace di consigliare al meglio al cliente con pazienza ed attenzione al particolare. Tempi di consegna rapidi e qualità del prodotto finale ottima. Super consigliati!'
  }
];

export default function Home() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % interiorImages.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReviewIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 15000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <main className="min-h-screen">
      <SEO
        title="Centro Ottico a Torino"
        description="Ottica Bellodi: centro ottico a Torino dal 1955. Occhiali da vista, occhiali da sole, lenti a contatto e montature su misura. Corso Giovanni Agnelli 104/B."
        canonical="/"
        image="/hero-home-ottica-bellodi-torino.webp"
        schema={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Ottica Bellodi Torino",
          "url": "https://www.otticabellodi.it",
          "description": "Ottica Bellodi: centro ottico a Torino dal 1955. Occhiali da vista, occhiali da sole, lenti a contatto e montature su misura.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.otticabellodi.it/blog/?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }}
      />
      {/* Hero Section */}
      <HeroSection
        imageSrc="/hero-home-ottica-bellodi-torino.webp"
        imageAlt="Ottica Bellodi Torino - Occhiali su misura"
        imagePosition="right"
        priority={true}
        title="Ottica Bellodi, la tua vista in buone mani"
        subtitle="Dal 1955 a Torino: occhiali da vista, da sole, lenti a contatto e montature stampate in 3D."
        buttons={[
          { variant: 'primary', href: '/soluzioni/', text: 'Scopri le Soluzioni' }
        ]}
      />

      {/* Nuovi Arrivi */}
      {(() => {
        const brandMeta = getBrandBySlug(NEW_ARRIVALS_BRAND);
        const products = Object.entries(getCatalogImages(NEW_ARRIVALS_BRAND)).slice(0, 4);
        if (!brandMeta || products.length === 0) return null;

        return (
          <Section className="bg-white">
            <Container>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
                {/* Foto campagna */}
                <div className="relative aspect-square rounded-lg overflow-hidden shadow-lg order-1">
                  <img
                    src="/dsquared-nuovi-arrivi.webp"
                    alt={`${brandMeta.name} — nuova collezione da Ottica Bellodi Torino`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>

                {/* Testo */}
                <div className="order-2">
                  <DiamondDivider className="mb-6" />
                  <span className="inline-block text-xs font-semibold px-3 py-1 rounded-full mb-4 bg-accent/10 text-accent">
                    Nuovi Arrivi
                  </span>
                  <h2 className="font-serif text-4xl font-semibold text-primary mb-6">
                    Le Ultime Novità: {brandMeta.name}
                  </h2>
                  <p className="text-lg text-taupe mb-8">
                    Sono appena arrivati in negozio i nuovi modelli {brandMeta.name}. Vieni a scoprirli e a provarli da Ottica Bellodi a Torino.
                  </p>
                  <Button variant="primary" href={`/catalogo/${NEW_ARRIVALS_BRAND}/`}>
                    Scopri tutta la collezione {brandMeta.name}
                  </Button>
                </div>
              </div>

              {/* Griglia modelli */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
                {products.map(([productKey, photos]) => {
                  const productName = getProductDisplayName(NEW_ARRIVALS_BRAND, productKey) ?? formatProductName(productKey);
                  return (
                    <a
                      key={productKey}
                      href={`/catalogo/${NEW_ARRIVALS_BRAND}/`}
                      className="group bg-white border border-taupe-light/40 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="aspect-square overflow-hidden">
                        <img
                          src={photos[0]}
                          alt={`${productName} — nuovo arrivo da Ottica Bellodi Torino`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="p-3 md:p-4">
                        <h3 className="font-serif text-primary text-sm md:text-base truncate">
                          {productName}
                        </h3>
                      </div>
                    </a>
                  );
                })}
              </div>
            </Container>
          </Section>
        );
      })()}

      {/* Brand Trust (desktop only) */}
      <Section className="hidden md:block bg-white !py-8 md:!py-12 md:!pt-16">
        <Container>
          <BrandLogos />
        </Container>
      </Section>

      {/* Chi Siamo Preview */}
      <Section className="bg-white">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Colonna immagini (50%) */}
            <div className="relative aspect-square rounded-lg overflow-hidden shadow-lg">
              <img
                src={interiorImages[currentImageIndex]}
                srcSet={`${interiorImages[currentImageIndex].replace('.webp', '-sm.webp')} 500w, ${interiorImages[currentImageIndex]} 760w`}
                sizes="(max-width: 768px) 500px, 760px"
                alt="Interno negozio Ottica Bellodi Torino"
                width="760"
                height="760"
                className="w-full h-full object-cover transition-opacity duration-500"
              />
            </div>
            
            {/* Colonna testo (50%) */}
            <div>
              <DiamondDivider className="mb-6" />
              <h2 className="font-serif text-4xl font-semibold text-primary mb-6">Chi Siamo</h2>
              <p className="text-lg text-taupe mb-8">
                Da tre generazioni offriamo un'ottica realmente personalizzata: lenti progressive progettate tramite realtà virtuale, montature su misura su scansione 3D del volto e un approccio che nasce dalla nostra lunga esperienza.
              </p>
              <Button variant="primary" href="/chi-siamo/">
                Scopri di Più
              </Button>
            </div>
          </div>
        </Container>
      </Section>

      {/* Assicurazioni */}
      <DecorativeSection>
        <Container>
          <h3 className="font-serif text-2xl text-center text-primary mb-8">
            Azienda convenzionata con le assicurazioni
          </h3>
          <InsuranceLogos />
        </Container>
      </DecorativeSection>

      {/* Soluzioni Preview */}
      <Section>
        <Container>
          <div className="text-center mb-12">
            <DiamondDivider className="mb-6 max-w-xs mx-auto" />
            <h2 className="font-serif text-4xl font-semibold text-primary mb-6">Le Nostre Soluzioni</h2>
            <p className="text-lg text-taupe max-w-3xl mx-auto">
              Ogni servizio nasce dall'incontro tra esperienza, tecnologia avanzata e ascolto delle tue reali esigenze visive. Che tu abbia bisogno di occhiali, lenti a contatto o di una soluzione completamente su misura, troverai sempre consulenza dedicata e attenzione ai dettagli.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Occhiali da Vista */}
            <ServiceCard 
              imageSrc="/occhiali-da-vista-ottica-bellodi-torino.webp"
              imageAlt="Occhiali da vista Ottica Bellodi Torino"
              title="Occhiali da vista"
              description="Montature e lenti personalizzate per te. Ti accompagniamo nella scelta perfetta tra estetica, funzionalità e comfort."
              buttonHref="/occhiali-da-vista/"
            />

            {/* Occhiali da Sole */}
            <ServiceCard 
              imageSrc="/occhiali-da-sole-ottica-bellodi-torino.webp"
              imageAlt="Occhiali da sole Ottica Bellodi Torino"
              title="Occhiali da Sole"
              description="Protezione totale dai raggi UV con design e stile. Selezioniamo solo modelli che uniscono eleganza e sicurezza."
              buttonHref="/occhiali-da-sole/"
            />

            {/* Lenti a Contatto */}
            <ServiceCard 
              imageSrc="/lenti-a-contatto-ottica-bellodi-torino.webp"
              imageAlt="Lenti a contatto Ottica Bellodi Torino"
              title="Lenti a Contatto"
              description="Libertà di movimento con massima precisione visiva. Ti guidiamo nella scelta ideale per i tuoi occhi e il tuo stile di vita."
              buttonHref="/lenti-a-contatto/"
            />

            {/* Montature su Misura */}
            <ServiceCard 
              imageSrc="/montature-lenti-su-misura-ottica-bellodi-torino.webp"
              imageAlt="Montature e lenti su misura Ottica Bellodi Torino"
              title="Montature Stampate 3D"
              description="Montature e lenti progettate esclusivamente per te con tecnologia di stampa 3D. Comfort assoluto, estetica impeccabile, prestazioni visive elevate."
              buttonHref="/montature-stampate-3d/"
            />
          </div>
        </Container>
      </Section>

      {/* Testimonial */}
      <DecorativeSection>
        <Container>
          <DiamondDivider className="mb-6 max-w-xs mx-auto" />
          <h2 className="font-serif text-4xl text-center font-semibold text-primary mb-12">Dicono di Noi</h2>
          
          <div className="max-w-2xl mx-auto">
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-md transition-opacity duration-500 card-inner-border">
              <div className="text-2xl mb-4 text-center text-accent">⭐⭐⭐⭐⭐</div>
              <p className="text-taupe italic text-base md:text-lg text-center mb-4 leading-relaxed">
                "{testimonials[currentReviewIndex].text}"
              </p>
              <h3 className="font-semibold text-base text-primary text-center">
                {testimonials[currentReviewIndex].name}
              </h3>
            </div>
            
            {/* Indicatori */}
            <div className="flex justify-center gap-1 mt-6">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentReviewIndex(index)}
                  className="p-2 flex items-center justify-center"
                  aria-label={`Vai alla recensione ${index + 1}`}
                >
                  <span className={`block rounded-full transition-all ${
                    index === currentReviewIndex
                      ? 'bg-accent w-6 h-3'
                      : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
                  }`} />
                </button>
              ))}
            </div>
          </div>

          <div className="text-center mt-10">
            <Button 
              variant="primary"
              href="https://www.google.com/maps/place/Ottica+Bellodi+-+Ottico+Torino+Santa+Rita/@45.0366684,7.6439454,17.02z/data=!3m1!5s0x47881329cd73f71b:0xcd87a2d1b26b0b8c!4m17!1m8!3m7!1s0x4788132832d44731:0x2b4b0482bdd9ea5c!2sCorso+Giovanni+Agnelli,+104,+10137+Torino+TO!3b1!8m2!3d45.0346498!4d7.6439308!16s%2Fg%2F11q2nfj88_!3m7!1s0x4788132832cb31a9:0xd0ae8aee273560b4!8m2!3d45.0346773!4d7.6439152!9m1!1b1!16s%2Fg%2F1v2d_c_y?entry=ttu&g_ep=EgoyMDI2MDIxNi4wIKXMDSoASAFQAw%3D%3D"
              external
            >
              Leggi tutte le recensioni su Google
            </Button>
          </div>
        </Container>
      </DecorativeSection>

      {/* Ultimi articoli dal blog */}
      {(() => {
        const latestPosts = getAllPosts().slice(0, 3);
        return (
          <Section className="bg-white">
            <Container>
              <div className="text-center mb-12">
                <DiamondDivider className="mb-6 max-w-xs mx-auto" />
                <h2 className="font-serif text-4xl font-semibold text-primary mb-4">Dal nostro Blog</h2>
                <p className="text-lg text-taupe max-w-2xl mx-auto">
                  Consigli, approfondimenti e novità dal mondo dell'ottica.
                </p>
              </div>
              <div className="grid md:grid-cols-3 gap-8">
                {latestPosts.map((post) => (
                  <a
                    key={post.slug}
                    href={`/blog/${post.slug}/`}
                    className="group block bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow card-inner-border"
                  >
                    {post.image && (
                      <div className="aspect-video overflow-hidden">
                        <img
                          src={post.image}
                          alt={post.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                    )}
                    <div className="p-8 flex flex-col flex-grow">
                      {post.date && (
                        <div className="mb-4">
                          <time className="pill-tag">
                            {formatDate(post.date)}
                          </time>
                        </div>
                      )}
                      <h3 className="font-serif text-xl text-primary mb-3 leading-snug group-hover:text-accent-dark transition-colors duration-300">
                        {post.title}
                      </h3>
                      {post.excerpt && (
                        <p className="text-sm text-taupe line-clamp-3 leading-relaxed">{post.excerpt}</p>
                      )}
                    </div>
                  </a>
                ))}
              </div>
              <div className="text-center mt-10">
                <Button variant="secondary" href="/blog/">
                  Leggi tutti gli articoli
                </Button>
              </div>
            </Container>
          </Section>
        );
      })()}

      {/* Perché scegliere Ottica Bellodi */}
      <Section className="bg-white !py-8 md:!py-12">
        <Container>
          <DiamondDivider className="mb-6 max-w-xs mx-auto" />
          <h2 className="font-serif text-4xl text-center font-semibold text-primary mb-12">
            Perché scegliere Ottica Bellodi
          </h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="flex gap-4">
              <div className="text-accent text-2xl">✓</div>
              <div>
                <h3 className="font-semibold text-lg text-primary mb-2">70 anni di esperienza familiare</h3>
                <p className="text-taupe">Una tradizione che si tramanda da tre generazioni.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-accent text-2xl">✓</div>
              <div>
                <h3 className="font-semibold text-lg text-primary mb-2">Strumentazione futuristica (VR + eyetracking)</h3>
                <p className="text-taupe">Precisione impossibile con metodi tradizionali.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-accent text-2xl">✓</div>
              <div>
                <h3 className="font-semibold text-lg text-primary mb-2">Lenti sartoriali su 6+ parametri</h3>
                <p className="text-taupe">Progettate sulle tue abitudini visive reali.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-accent text-2xl">✓</div>
              <div>
                <h3 className="font-semibold text-lg text-primary mb-2">Montature su misura con scansione 3D</h3>
                <p className="text-taupe">Fit perfetto basato sulla riproduzione digitale del tuo volto.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-accent text-2xl">✓</div>
              <div>
                <h3 className="font-semibold text-lg text-primary mb-2">Zero standardizzazione</h3>
                <p className="text-taupe">Ogni occhiale è unico, costruito intorno a te.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-accent text-2xl">✓</div>
              <div>
                <h3 className="font-semibold text-lg text-primary mb-2">Assistenza continua, anche post-vendita</h3>
                <p className="text-taupe">Ti seguiamo in ogni fase.</p>
              </div>
            </div>
          </div>
        </Container>
      </Section>
    </main>
  );
}